<div class="flex flex-col items-center justify-center bottom-[50px] z-[5]">
  @if (!showMenu()) {
    <button
      class="menu-button bg-white rounded-full w-14 h-14 flex items-center justify-center shadow-md hover:bg-gray-50 transition-colors"
      (click)="openMenu()"
      color="primary"
      [matTooltip]="'Title.MainTitle.SpatialAnalysis' | transloco"
      [disabled]="permissionService.isBlockedByQuota()"
    >
      <mat-icon svgIcon="icn-move" />
    </button>
  }

  @if (showMenu()) {
    <div class="flex flex-col bg-transparent z-[5] items-center justify-center">
      <div class="bg-primary-accumin-white rounded-t-[50px] h-6 w-full flex flex-col"></div>
      <div class="bg-primary-accumin-white w-full flex flex-col">
        @for (mode of modes(); track mode) {
          <div class="flex flex-col items-center justify-center mb-4">
            <app-task-icon [config]="mode" (taskIconClicked)="triggerTaskIconClick(mode)" />
          </div>
        }
      </div>
      <button
        class="flex items-center justify-center bg-primary-accumin-black-05 p-4 rounded-b-[50px] border-l border-primary-accumin-black-05 cursor-pointer"
        (click)="closeMenu()"
        (keyup.enter)="closeMenu()"
        [matTooltip]="'Button.Close' | transloco"
        aria-label="Close menu"
      >
        <mat-icon svgIcon="icn-close" />
      </button>
    </div>
  }
</div>
